import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteCakeLabel, getCakeLabels, getProductListCategory, sellCakeLabel, updateDateCakeLabel } from '../services/catalogServices';
import Toast from '../helpers/Toast';
import Spinner from '../helpers/Spinner';
import { AuthContext } from '../../context/Auth.context';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { isElectron } from '../functions/isElectron';
import { FakeIpcRenderer } from '../helpers/FakeIpcRenderer';
import { dateFormat } from '../functions/dateFormat';

let ipcRenderer = FakeIpcRenderer;

if (isElectron()) {
    ipcRenderer = window.require("electron").ipcRenderer;
    ipcRenderer.removeAllListeners('generate-ticket-reply');
}

const CakeLabels = () => {

    const cartInitialValue = { productList: [], payment: 0, total: 0, discount: 0, paymentMethod: 1, change: 0, notes: '', split: false, payInDlls: false, paymentDlls: 0, changeDlls: 0, totalDlls: 0, partial: false, secondPaymentMethod: 0, secondPayment: 0, date: '' };
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pages_saled, setPages_saled] = useState([]);
    const [total_current_saled, setTotal_current_saled] = useState(1);
    const [current_page_saled, setCurrent_page_saled] = useState(1);
    const [first_item_saled, setFirst_item_saled] = useState(1);
    const [last_item_saled, setLast_item_saled] = useState(1);
    const [pages_no_saled, setPages_no_saled] = useState([]);
    const [total_current_no_saled, setTotal_current_no_saled] = useState(1);
    const [current_page_no_saled, setCurrent_page_no_saled] = useState(1);
    const [first_item_no_saled, setFirst_item_no_saled] = useState(1);
    const [last_item_no_saled, setLast_item_no_saled] = useState(1);
    const { state, CheckResponse } = useContext(AuthContext);
    const [saled_labels, setSaledLabels] = useState([]);
    const [no_saled_labels, setNoSaledLabels] = useState([]);
    const [show_saled, setShowSaled] = useState(false);
    const [modal_sell_label_preview, setModalSellLabelPreview] = useState(false);
    const [modal_date_label_preview, setModalDateLabelPreview] = useState(false);
    const [modal_delete_label_preview, setModalDeleteLabelPreview] = useState(false);
    const [current_label, setCurrentLabel] = useState([]);
    const [is_selected_label, setIsSelectedLabel] = useState(false);
    const [reload, setReload] = useState(false);
    const [date_form_label, setDateFormLabel] = useState("");
    const [date_from, setDateFrom] = useState("");
    const [date_to, setDateTo] = useState("");
    const [cart, setCart] = useState(cartInitialValue);
    const [cake_list, setCakeList] = useState([]);

    const showToast = (t, d, tt) => {
        setList([...list, {
            id: Math.floor((Math.random() * 101) + 1),
            title: t,
            description: d,
            type: tt
        }]);
    }

    useEffect(() => {
        loadLabels();
        if (isElectron()) {
            ipcRenderer = window.require("electron").ipcRenderer;
            ipcRenderer.removeAllListeners('generate-ticket-reply');

            ipcRenderer.on("generate-ticket-reply", (event, args) => {
                if (args == false) {
                    showToast('Oops!', 'No se pudo imprimir, revisa tu impresora o configuracion', 'danger');
                } else {
                    showToast('Hecho!', 'informacion guardada con exito', 'success');
                }

            });
        }
    }, [show_saled, current_page_saled, current_page_no_saled, reload]);


    const generateDataTicket = () => {
        let filteredData = saled_labels.filter(label => {
            const sold = new Date(label.sold);
            const from = new Date(date_from);
            const to = new Date(date_to);
            return sold >= from && sold <= to;
        });
        let newProducts = filteredData.map(label => {
            return {
                id: label.id_producto,
                name: label.number + ' ' + label.product_name,
                price: label.product_price,
                qty: 1
            };
        }).filter(product => product !== null);

        setCakeList(newProducts);
    };

    useEffect(() => {
        if (cake_list.length > 0) {
            const newTotal = cake_list.reduce((acc, product) => acc + (product.price * product.qty), 0);
            const updatedCart = {
                ...cart,
                productList: cake_list,
                total: newTotal,
                payment: newTotal - cart.discount,
                change: 0,
                date: new Date().toISOString(),
            };

            setCart(updatedCart);
        }

    }, [cake_list]);

    useEffect(() => {
        if (cart.productList.length > 0) {
            ipcRenderer.send("generate-ticket", JSON.stringify({ data: cart, config: state.config }));
        }
    }, [cart])

    const generateTicket = () => {
        if (date_from && date_to) {
            generateDataTicket();
        } else {
            showToast('Oops!', 'Selecciona un rango de fechas correcto', 'warning');
        }
    };

    const filterCakeLabels = () => {
        if (date_from && date_to) {
            setShowSaled(true);
            setReload((reload) => !reload);
        } else {
            showToast('Oops!', 'Selecciona un rango de fechas correcto', 'warning');
        }
    }

    const changueShowedLabels = () => {
        setShowSaled((prevShowSaled) => !prevShowSaled);
        setDateFrom('');
        setDateTo('');
        loadLabels();
    }

    const loadLabels = () => {
        setLoading(true);
        if (show_saled) {
            if (date_from && date_to) {
                getCakeLabels(state.auth, 10, current_page_saled, date_from, date_to).then(data => {
                    CheckResponse(data);
                    if (data.code == 200) {
                        setSaledLabels(data.cake_labels_saled);
                        setPages_saled(data.pages_saled);
                        setTotal_current_saled(data.total_current_saled);
                        setCurrent_page_saled(data.current_page_saled);
                        setFirst_item_saled(data.first_item_saled);
                        setLast_item_saled(data.last_item_saled);

                    } else {
                        showToast('Oops!', 'Algo salio mal!', 'danger');
                    }
                })
                    .finally(setLoading(false));
            } else {
                getCakeLabels(state.auth, 10, current_page_saled, 0, 0).then(data => {
                    CheckResponse(data);
                    if (data.code == 200) {
                        setSaledLabels(data.cake_labels_saled);
                        setPages_saled(data.pages_saled);
                        setTotal_current_saled(data.total_current_saled);
                        setCurrent_page_saled(data.current_page_saled);
                        setFirst_item_saled(data.first_item_saled);
                        setLast_item_saled(data.last_item_saled);

                    } else {
                        showToast('Oops!', 'Algo salio mal!', 'danger');
                    }
                })
                    .finally(setLoading(false));
            }
        } else {
            getCakeLabels(state.auth, 10, current_page_no_saled).then(data => {
                CheckResponse(data);
                if (data.code == 200) {
                    setNoSaledLabels(data.cake_labels_no_saled);
                    setPages_no_saled(data.pages_no_saled);
                    setTotal_current_no_saled(data.total_current_no_saled);
                    setCurrent_page_no_saled(data.current_page_no_saled);
                    setFirst_item_no_saled(data.first_item_no_saled);
                    setLast_item_no_saled(data.last_item_no_saled);
                } else {
                    showToast('Oops!', 'Algo salio mal!', 'danger');
                }
            })
                .finally(setLoading(false));
        }
    }

    const sellLabelCakeModal = (label) => {
        setCurrentLabel(label);
        setIsSelectedLabel(true);
        setModalSellLabelPreview(true);
    }
    const closeSellLabelModal = () => {
        setCurrentLabel([]);
        setIsSelectedLabel(false);
        setModalSellLabelPreview(false);
    }

    const dateLabelCakeModal = (label) => {
        setCurrentLabel(label);
        setDateFormLabel(show_saled ? label.sold.split(" ")[0] : label.registered.split(" ")[0]);
        setIsSelectedLabel(true);
        setModalDateLabelPreview(true);
    }
    const closeDateLabelModal = () => {
        setCurrentLabel([]);
        setDateFormLabel('');
        setIsSelectedLabel(false);
        setModalDateLabelPreview(false);
    }

    const deleteLabelCakeModal = (label) => {
        setCurrentLabel(label);
        setIsSelectedLabel(true);
        setModalDeleteLabelPreview(true);
    }
    const closeDeleteLabelModal = () => {
        setCurrentLabel([]);
        setIsSelectedLabel(false);
        setModalDeleteLabelPreview(false);
    }
    const sellLabel = () => {
        let error = false;
        if (!error) {
            sellCakeLabel(state.auth, current_label.id).then(data => {
                CheckResponse(data);
                if (data.code == 200) {
                    showToast('Hecho!', 'Guardado con exito', 'success');
                    closeSellLabelModal();
                    setReload((reload) => !reload)
                } else {
                    showToast('Oops!', 'Algo salio mal!', 'danger');
                    closeSellLabelModal();
                    setLoading(false)
                }
            });
        }
    }

    const setDateLabel = () => {
        let error = false;
        if (!error) {
            updateDateCakeLabel(state.auth, current_label.id, show_saled ? 1 : 0, date_form_label).then(data => {
                CheckResponse(data);
                if (data.code == 200) {
                    showToast('Hecho!', 'Guardado con exito', 'success');
                    closeDateLabelModal();
                    setReload((reload) => !reload)
                } else {
                    showToast('Oops!', 'Algo salio mal!', 'danger');
                    closeDateLabelModal();
                    setLoading(false)
                }
            });
        }
    }

    const deleteLabel = () => {
        let error = false;
        if (!error) {
            deleteCakeLabel(state.auth, current_label.id).then(data => {
                CheckResponse(data);
                if (data.code == 200) {
                    showToast('Hecho!', 'Eliminado con exito', 'success');
                    closeDeleteLabelModal();
                    setReload((reload) => !reload)
                } else {
                    showToast('Oops!', 'Algo salio mal!', 'danger');
                    closeDeleteLabelModal();
                    setLoading(false)
                }
            });
        }
    }

    const handleChangeDateLabel = (event) => {
        setDateFormLabel(event.target.value);
    };

    const handleChangeDateFrom = (event) => {
        setDateFrom(event.target.value);
    };

    const handleChangeDateTo = (event) => {
        setDateTo(event.target.value);
    };

    const processDataLabels = (saled_labels) => {
        return saled_labels.map(label => {
            const registeredDate = new Date(label.registered);
            const soldDate = new Date(label.sold);

            return {
                No: label.id,
                Descripcion: label.product_name,
                "# Pastel": label.number,
                Precio: label.product_price,
                "Fecha Recibido": `${registeredDate.getDate()}-${(registeredDate.getMonth() + 1)}-${registeredDate.getFullYear()}`,
                "Fecha Venta": `${soldDate.getDate()}-${(soldDate.getMonth() + 1)}-${soldDate.getFullYear()}`,
                "Dias en vitrina": Math.floor((soldDate - registeredDate) / (1000 * 60 * 60 * 24)),
                "Cajera": label.id_user
            };
        });
    };

    const makeExcel = () => {
        if (date_from && date_to) {
            setLoading(true);

            const filteredData = saled_labels.filter(label => {
                const sold = new Date(label.sold);
                const from = new Date(date_from);
                const to = new Date(date_to);
                return sold >= from && sold <= to;
            });

            const processedData = processDataLabels(filteredData);

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Pasteles');

            const header = ["No", "Descripcion", "# Pastel", "Precio", "Fecha Recibido", "Fecha Venta", "Dias en vitrina", "Cajera"];
            worksheet.addRow(header);

            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, color: { argb: 'FFFFFF' } };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            });

            processedData.forEach((row) => {
                worksheet.addRow([row.No, row.Descripcion, row["# Pastel"], row.Precio, row["Fecha Recibido"], row["Fecha Venta"], row["Dias en vitrina"], row.Cajera]);
            });

            worksheet.columns.forEach((column) => {
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, (cell) => {
                    const cellValue = cell.value ? cell.value.toString() : '';
                    maxLength = Math.max(maxLength, cellValue.length);
                });
                column.width = maxLength + 2;
            });

            workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                saveAs(blob, `reporte venta de pasteles ${date_from}-${date_to}.xlsx`);
            });

            setTimeout(() => {
                showToast('Hecho!', 'Reporte descargado', 'success');
                setLoading(false);
            }, 3000);
        } else {
            showToast('Oops!', 'Selecciona un rango de fechas correcto', 'warning');
        }
    };

    return (
        <>
            <Toast
                toastList={list}
            />
            <div className="row">
                <div className="col-sm-4">
                    <h1>Etiquetas</h1>
                </div>
            </div>
            {!loading && <>
                <div className="row mt-2">

                    <div className="col-sm-4 mt-1">
                        <label>De:</label>
                        <input type="date" value={date_from} onChange={(e) => handleChangeDateFrom(e)} className='form-control'></input>
                    </div>
                    <div className="col-sm-4 mt-1">
                        <label>A:</label>
                        <input type="date" value={date_to} onChange={(e) => handleChangeDateTo(e)} className='form-control'></input>
                    </div>
                    <div className="col-sm-4 mt-1">
                        <button className="btn btn-primary mt-4 me-2" onClick={() => { filterCakeLabels() }}>Buscar Etiquetas</button>
                        <Link className="btn btn-success mt-4" to={`/cake-labels/add`} state={{}} role="button">Agregar Etiqueta</Link>
                    </div>
                    {show_saled && <><div className="col-sm-1 mt-1">
                        <button className="btn btn-primary mt-4" onClick={() => { makeExcel() }}>Excel</button>
                    </div></>}
                    {isElectron() && show_saled && <><div className="col-sm-2 mt-1">
                        <button className="btn btn-primary mt-4" onClick={() => { generateTicket() }}>Imprimir Etiquetas</button>
                    </div></>}
                    <div className="col-sm-2 mt-1">
                        <button className="btn btn-primary mt-4" onClick={() => changueShowedLabels()}>{show_saled ? 'Ver no vendidos' : 'Ver vendidos'}</button>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-sm-12">
                        {show_saled ? <>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Producto</th>
                                        <th>Precio</th>
                                        <th>Etiqueta</th>
                                        <th>Fecha Entrada</th>
                                        <th>Fecha Venta</th>
                                        <th>Vendio</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {saled_labels?.map(item =>
                                        <tr key={item.id}>
                                            <th>{item.id}</th>
                                            <th>{item.product_name}</th>
                                            <td>{item.product_price}</td>
                                            <td>{item.number}</td>
                                            <th>{dateFormat(item.registered)}</th>
                                            <th>{dateFormat(item.sold)}</th>
                                            <th>{item.id_user}</th>
                                            <th><button className="btn btn-primary" onClick={() => { dateLabelCakeModal(item) }}>Editar fecha de salida</button>
                                            {state.auth.type != 3 && <button className="btn btn-danger ms-1" onClick={() => { deleteLabelCakeModal(item) }}>Eliminar</button>}</th>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <ul className="pagination">
                                        {pages_saled.map(page =>
                                            <Fragment key={page}>
                                                {current_page_saled === page ?
                                                    <span key={page} className="page-link active me-2" style={{ "width": "40px", "textAlign": "center" }}>{page}</span>
                                                    :
                                                    <li key={page} className="page-page me-2" style={{ "width": "40px", "textAlign": "center" }}><a className="page-link" onClick={() => setCurrent_page_saled(page)}>{page}</a></li>
                                                }
                                            </Fragment>
                                        )}
                                    </ul>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <p className="text-sm-start mt-2">Mostrando <b>{first_item_saled}</b> a <b>{last_item_saled}</b> de un total de <b>{total_current_saled}</b></p>
                                </div>
                            </div>
                        </> : <>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Producto</th>
                                        <th>Precio</th>
                                        <th>Etiqueta</th>
                                        <th>Fecha Entrada</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {no_saled_labels?.map(item =>
                                        <tr key={item.id}>
                                            <th>{item.id}</th>
                                            <th>{item.product_name}</th>
                                            <td>{item.product_price}</td>
                                            <td>{item.number}</td>
                                            <th>{dateFormat(item.registered)}</th>
                                            <th><button className="btn btn-primary" onClick={() => { sellLabelCakeModal(item) }}>Marcar como vendido</button></th>
                                            <th><button className="btn btn-primary" onClick={() => { dateLabelCakeModal(item) }}>Editar fecha de entrada</button>
                                            {state.auth.type != 3 && <button className="btn btn-danger ms-1" onClick={() => { deleteLabelCakeModal(item) }}>Eliminar</button>}</th>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <ul className="pagination">
                                        {pages_no_saled.map(page =>
                                            <Fragment key={page}>
                                                {current_page_no_saled === page ?
                                                    <span key={page} className="page-link active me-2" style={{ "width": "40px", "textAlign": "center" }}>{page}</span>
                                                    :
                                                    <li key={page} className="page-page me-2" style={{ "width": "40px", "textAlign": "center" }}><a className="page-link" onClick={() => setCurrent_page_no_saled(page)}>{page}</a></li>
                                                }
                                            </Fragment>
                                        )}
                                    </ul>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <p className="text-sm-start mt-2">Mostrando <b>{first_item_no_saled}</b> a <b>{last_item_no_saled}</b> de un total de <b>{total_current_no_saled}</b></p>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </>}
            {loading && <div className="col-sm-4 mt-1">
                <Spinner size={3} margin={4}></Spinner>
            </div>}


            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modal_sell_label_preview ? 'block' : 'none' }}>
                <div className="modal-dialog">

                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Marcar como vendido?</h5>
                            <button onClick={() => { closeSellLabelModal() }} type="button" className="btn-close"></button>
                        </div>
                        <div className="modal-body">
                            <h5>Pastel</h5>
                            <p>{is_selected_label && current_label.product_name}</p>
                            <h5>Etiqueta</h5>
                            <p>{is_selected_label && current_label.number}</p>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => { closeSellLabelModal() }} className="btn btn-danger" type="button">No</button>
                            <button type="button" onClick={() => { sellLabel() }} className="btn btn-success">Si</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modal_date_label_preview ? 'block' : 'none' }}>
                <div className="modal-dialog">

                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Editar Etiqueta</h5>
                            <button onClick={() => { closeDateLabelModal() }} type="button" className="btn-close"></button>
                        </div>
                        <div className="modal-body">
                            <h5>Pastel</h5>
                            <p>{is_selected_label && current_label.product_name}</p>
                            <h5>Etiqueta</h5>
                            <p>{is_selected_label && current_label.number}</p>
                            <label>Fecha de {show_saled ? 'venta' : 'entrada'}</label>
                            <input type="date" value={date_form_label} onChange={(e) => handleChangeDateLabel(e)} className='form-control'></input>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => { closeDateLabelModal() }} className="btn btn-danger" type="button">No</button>
                            <button type="button" onClick={() => { setDateLabel() }} className="btn btn-success">Si</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modal_delete_label_preview ? 'block' : 'none' }}>
                <div className="modal-dialog">

                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Eliminar Etiqueta?</h5>
                            <button onClick={() => { closeDeleteLabelModal() }} type="button" className="btn-close"></button>
                        </div>
                        <div className="modal-body">
                            <h5>Pastel</h5>
                            <p>{is_selected_label && current_label.product_name}</p>
                            <h5>Etiqueta</h5>
                            <p>{is_selected_label && current_label.number}</p>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => { closeDeleteLabelModal() }} className="btn btn-primary" type="button">Cancelar</button>
                            <button type="button" onClick={() => { deleteLabel() }} className="btn btn-danger">Confirmar</button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default CakeLabels;